module.exports = __webpack_public_path__ + "static/media/Technologybanner@3x.cb94622a.png";